module.exports = __webpack_public_path__ + "static/media/twitter_icon.a66e8ec2.png";